import React from 'react';
import { Form, Table, Row, Col } from 'antd';
import SelectorTreeOrganization from '@/form-component/select-organizations';

export default function OpenForOganazation(props) {
  const { onChange = () => {}, value = [] } = props;

  // {
  //   id: 'id',
  //   organization: '/00000000/00000840/00003044/00007646/00007891/00007893',
  //   organizationName: '京东-总部-职能研发部-综合职能研发部-技术专家组'
  // }

  const columnsOrganization = [
    {
      title: '部门',
      dataIndex: 'organizationName',
      align: 'center',
    },
    {
      title: '操作',
      width: 100,
      render: (curItem) => {
        return (
          <a
            onClick={() => {
              onChange(value.filter((item) => item.organization !== curItem.organization));
            }}
          >
            删除
          </a>
        );
      },
      align: 'center',
    },
  ];

  return (
    <div className="wrap-select-open-scope">
      <Row>
        <Col span={7}>
          <Form.Item label="添加部门:">
            <SelectorTreeOrganization
              onChange={onChange}
              value={value}
              className="hide-con-in-search-box"
              maxTagCount={0}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item noStyle>
        <Table
          className="table-width"
          rowKey="organizationName"
          pagination={false}
          columns={columnsOrganization}
          dataSource={value}
        />
      </Form.Item>
    </div>
  );
}
